import axios from "axios";
import { handleRequestError, memoizePromiseFn } from "../../requests";


export const getCreditLookup = async (lookup) => {
  const results = await axios.post(`/DewarBilling/CreditCardLookup`, lookup).catch(handleRequestError);
  return results.data;
}
export const RetryTransactions = async (transactions) => {
  const results = await axios.post(`/DewarBilling/RetryTransactions`, transactions).catch(handleRequestError);
  return results.data;
}
export const ApproveTransactions = async (transactions) => {
  const results = await axios.post(`/DewarBilling/ApproveTransactions`, transactions).catch(handleRequestError);
  return results.data;
}


export const GetCreditCardTransactionsThatNeedApproval = async () => {
  const results = await axios.get(`/DewarBilling/GetCreditCardTransactionsThatNeedApproval`).catch(handleRequestError);
  return results.data;
}
export const GetFailedTransactions = async () => {
  const results = await axios.get(`/DewarBilling/GetFailedTransactions`).catch(handleRequestError);
  return results.data;
}
export const GetOpenPreAuthorizations = async () => {
  const results = await axios.get(`/DewarBilling/GetOpenPreAuthorizations`).catch(handleRequestError);
  return results.data;
}
export const GetCompletedCreditCardTransactions = async () => {
  const results = await axios.get(`/DewarBilling/GetCompletedCreditCardTransactions`).catch(handleRequestError);
  return results.data;
}
export const GetVoidedCreditCardTransactions = async () => {
  const results = await axios.get(`/DewarBilling/GetVoidedCreditCardTransactions`).catch(handleRequestError);
  return results.data;
}




export const GetJDEInfoFromCST = async (cst) => {
  const results = await axios.get(`/DewarBilling/GetJDEInfoFromCST/${cst}`).catch(handleRequestError);
  return results.data;
}
export const insertDewarRule = async (rule) => {
  const results = await axios.post('/DewarBilling/insertDewarRule', rule).catch(handleRequestError);
  return results.data;
}

export const getDewarRules = async () => {
  const results = await axios.get(`/DewarBilling/GetDewarRules`).catch(handleRequestError);
  return results.data;
}
export const updateDewarRule = async (rule) => {
  const results = await axios.put(`/DewarBilling/UpdateDewarRule`, rule).catch(handleRequestError);
  return results.data;
}
export const deleteDewarRule = async (ruleId) => {
  const results = await axios.delete(`/DewarBilling/DeleteDewarRule/${ruleId}`).catch(handleRequestError);
  return results.data;
}
//		//BypassInvoiceFromInvoice(int billingId)

export const BypassInvoiceFromInvoice = async (billingId) => {
  const results = await axios.post('/DewarBilling/BypassInvoiceFromInvoice', {billingId}).catch(handleRequestError);
  return results.data;
}

export const getInvoiceFromOrder = async (orderId) => {
  const results = await axios.get(`/DewarBilling/GetInvoiceFromOrder/${orderId}`).catch(handleRequestError);
  return results.data;
}

export const getPastVolumes = async () => {
  const results = await axios.get('/DewarBilling/getPastVolumes').catch(handleRequestError);
  return results.data;
}

export const jdeUploadByOrderIds = async (orderIds) => {
  const results = await axios.post('/DewarBilling/UploadInvoicesToJDEByOrderId', orderIds).catch(handleRequestError);
  return checkDewarUploadResults(results.data);
}
export const jdeUploadByBillingIDs = async (billingIds) => {
  const results = await axios.post('/DewarBilling/UploadInvoicesToJDEByBillingId', billingIds).catch(handleRequestError);
  return checkDewarUploadResults(results.data);
}

export interface DewarUploadResult {
  orderId: number | null;
  billingId: number | null;
  succeeded: boolean;
  message: string | null;
}

export const checkDewarUploadResults = (results: DewarUploadResult[]): DewarUploadResult[] => {
  if (!Array.isArray(results) || results.length === 0 || results.some(r => typeof r?.succeeded !== 'boolean')) {
    throw new Error('The server did not return invoice upload outcomes. Refresh the billing list and verify status before retrying.');
  }
  const failed = results.filter(r => !r.succeeded);
  if (failed.length) {
    throw new Error(
      `${failed.length} of ${results.length} invoices were not completed. Review these invoices before retrying:\n` +
      failed.map(r => `Invoice ${r.billingId ?? '(not created)'}, order ${r.orderId ?? '(unknown)'}: ${r.message ?? 'Review billing errors.'}`).join('\n')
    );
  }
  return results;
};
//bypassInvoiceFromOrder
export const bypassInvoiceFromOrder = async (orderId) => {
  const results = await axios.post('/DewarBilling/bypassInvoiceFromOrder', {orderId}).catch(handleRequestError);
  return results.data;
}

export const InsertBilling = async (billing) => {
  const results = await axios.post('/DewarBilling/InsertBilling', billing).catch(handleRequestError);
  return results.data;
}


export const getDewarPricing = async (cst) => {
  const results = await axios.get(`/DewarBilling/getDewarPricing/${cst}`).catch(handleRequestError);
  return results.data;
}

//getDewarInvoices
export const getDewarInvoices = async (queryDeg) => {
  const results = await axios.post(`/DewarBilling/GetBillingList`, queryDeg).catch(handleRequestError);
  return results.data;
}

export const getPendingManualUpload = async () => {
  const results = await axios.get(`/DewarBilling/GetPendingManualUpload`).catch(handleRequestError);
  return results.data;
}

export const GetDewarProductTypeList = async () => {
  const results = await axios.get('/DewarBilling/GetDewarProductTypeList').catch(handleRequestError);
  return results.data;
}
export const UpdateDewarProductType = async (productType) => {
  const results = await axios.put('/DewarBilling/UpdateDewarProductType', productType).catch(handleRequestError);
  return results.data;
}
export const InsertDewarProductType = async (productType) => {
  const results = await axios.post('/DewarBilling/InsertDewarProductType', productType).catch(handleRequestError);
  return results.data;
}

//////
export const deleteInvoice = async (invoiceId) => {
  const results = await axios.delete(`/DewarBilling/DeleteInvoice/${invoiceId}`).catch(handleRequestError);
  return results.data;
};
// /PreAuthorizeCreditCard
export const PreAuthorizeCreditCard = async (billingId) => {
  const results = await axios.get(`/DewarBilling/PreAuthorizeCreditCard/${billingId}`).catch(handleRequestError);
  return results.data;
};

export const getBillingHeader = async (billingId) => {
  const results = await axios.get(`/DewarBilling/getBillingHeader/${billingId}`).catch(handleRequestError);
  return results.data;
};

export const reverseBilling = async (reverse) => {
  const results = await axios.post(`/DewarBilling/reverseBilling`, reverse).catch(handleRequestError);
  return results.data;
};

export const uploadInvoicesJDEDTO = async (invoice) => {
  const results = await axios.post(`/DewarBilling/UploadInvoicesToJDE`, invoice).catch(handleRequestError);
  return results.data;
};

export const createDewarDamagesInvoice = async (invoice) => {
  const results = await axios.post(`/MiscBilling/createDewarDamagesInvoice`, invoice).catch(handleRequestError);
  return results.data;
};
export const getDewarDamageReport = async (customerId) => {
  const results = await axios.get(`/DewarBilling/getDewarDamageReport/${customerId}`).catch(handleRequestError);
  return results.data;
};
export const getDewarDamageReportHeaders = async (type) => {
  const results = await axios.get('/DewarBilling/GetDewarDamageReportHeaders').catch(handleRequestError);
  return results.data;
};
export const SendReport = async (report) => {
  const results = await axios.post('/DewarBilling/SendReport', report).catch(handleRequestError);
  return results.data;
};
export const downloadReport = async (report) => {
  const results = await axios.post('/DewarBilling/DownloadReport', report, { responseType: 'blob' }).catch(handleRequestError);

  const url = window.URL.createObjectURL(new Blob([results.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', report.filename);
  document.body.appendChild(link);
  link.click();
};
export const GetJDEErrors = async (billing) => {
  const results = await axios.get('/DewarBilling/GetJDEErrors').catch(handleRequestError);
  return results.data;
}
export const GetUnbilledInvoices = async (billing) => {
  const results = await axios.get('/DewarBilling/GetUnbilledInvoices').catch(handleRequestError);
  return results.data;
}

export const UpdateBilling = async (billing) => {
  const results = await axios.put('/DewarBilling/UpdateBilling', billing).catch(handleRequestError);
  return results.data;
}